var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87179 13C2.53501 13 2.24996 12.8833 2.01663 12.65C1.78329 12.4167 1.66663 12.1316 1.66663 11.7948V4.20517C1.66663 3.86839 1.78329 3.58333 2.01663 3.35C2.24996 3.11667 2.53501 3 2.87179 3H13.1281C13.4649 3 13.75 3.11667 13.9833 3.35C14.2166 3.58333 14.3333 3.86839 14.3333 4.20517V11.7948C14.3333 12.1316 14.2166 12.4167 13.9833 12.65C13.75 12.8833 13.4649 13 13.1281 13H2.87179ZM7.99996 8.37183L2.66663 4.9615V11.7948C2.66663 11.8547 2.68585 11.9039 2.72429 11.9423C2.76274 11.9808 2.8119 12 2.87179 12H13.1281C13.188 12 13.2372 11.9808 13.2756 11.9423C13.3141 11.9039 13.3333 11.8547 13.3333 11.7948V4.9615L7.99996 8.37183ZM7.99996 7.33333L13.2308 4H2.76913L7.99996 7.33333ZM2.66663 4.9615V4V11.7948C2.66663 11.8547 2.68585 11.9039 2.72429 11.9423C2.76274 11.9808 2.8119 12 2.87179 12H2.66663V4.9615Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.41d2a945d5b0c6b0616e9394878f24bf.svg";
export { ForwardRef as ReactComponent };